export default
{
    name: 'app-btn-filter',

    props:
    {
        to: {type: String, default: null}
    },

    methods:
    {
        _onMouseEnter()
        {
            this.$el.classList.add('is-hovered')
        },

        _onMouseLeave()
        {
            this.$el.classList.remove('is-hovered')
        },

        _onMouseClick(event)
        {
            if (this.to)
            {
                this.$root.changePage(this.to)
            }

            this.$emit('click', event)
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-btn-filter/script.js